import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTheme } from '../../../actions/layoutActions';
import classnames from 'classnames';

import './Theme.css';
import './red.css';
import './blue.css';


export class Theme extends Component {
  static propTypes = {
    theme: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    setTheme: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className={classnames('theme', {
        [this.props.theme]: this.props.theme !== 'DEFAULT'
      })}>
        {this.props.children}
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  theme: state.layout.theme
});

const mapDispatchToProps = {
  setTheme
};

export default connect(mapStateToProps, mapDispatchToProps)(Theme);



// WEBPACK FOOTER //
// ./src/components/layout/Theme/Theme.js